import { IonCheckbox, IonThumbnail, IonList, IonFooter, IonAvatar, IonRippleEffect, IonSpinner, useIonToast, useIonRouter, IonLoading, IonSelect, IonSelectOption, IonTextarea, IonIcon, IonGrid, IonRow, IonCol, IonText, IonImg, useIonViewWillEnter, IonActionSheet, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { locationOutline, chatboxEllipsesOutline, hammerOutline, filmOutline, linkOutline, chevronUpOutline, libraryOutline, readerOutline, logoYoutube, addOutline, chevronForwardOutline, arrowBackOutline, imagesOutline, closeOutline, closeCircleOutline, clipboardOutline, videocamOutline, imageOutline, newspaperOutline } from 'ionicons/icons';
import { Clipboard } from '@capacitor/clipboard';
import { Browser } from '@capacitor/browser';
import { Camera, ImageOptions, CameraResultType, GalleryPhoto, GalleryPhotos, PermissionStatus, CameraSource, Photo } from '@capacitor/camera';
import { FilePicker } from '@capawesome/capacitor-file-picker';
import { CapacitorVideoPlayer } from 'capacitor-video-player';
import { Capacitor } from '@capacitor/core';

import { showAlert, showConfirm } from '../components/Alert';
import NServer, { UIElement } from "../components/NServer";
import Vault from '../components/Vault';
import { LANGUAGE, GetStr } from "../language/Language";
import { ItemInfo } from "../data/item";

import LocationSelector, { Location, locationName } from "../components/LocationSelector";

import './Main.css'; 

interface AddContentProp extends RouteComponentProps<{
    type : string
    }> 
{}

const AddContent : React.FC<AddContentProp> = ({match}) => {

    //	Initializing our router
	const router = useIonRouter();
    const [name, setName] = useState("User");
    const [avatar, setAvatar] = useState("https://nwallet.site/img/avt.jpg");
    const [images, setImages] = useState<Photo[]>([]);
    const [addVideo, setAddVideo] = useState(false);
    const [videoCode, setVideoCode] = useState("");
    const [videoURL, setVideoURL] = useState("");
    const [addTitle, setAddTitle] = useState(false);
    const [title, setTitle] = useState("");
    const [desc, setDesc] = useState("");
    const [channel, setChannel] = useState(0);
    const [totalPosts, setTotalPosts] = useState(0);
    const [maxPosts, setMaxPosts] = useState(0);
    const [showToast, dismissToast] = useIonToast();
    const [maxFileSize, setMaxFileSize] = useState(1);
    const [contentMeta, setContentMeta] = useState(-1);

    const [addShow, setAddShow] = useState(false);
    const [metaList, setMetaList] = useState<ItemInfo[]>([]);
    const [showLoading, setShowLoading] = useState(false);
    const [nsfw, setNSFW] = useState(false);
    const [anoPost, setAnoPost] = useState(false);
    const [videoFile, setVideoFile] = useState("");
    const [showActBut, setShowActBut] = useState(false);
    const [actionButType, setActionButType] = useState("");
    const [actionButLbl, setActionButLbl] = useState("");

    const [itemPrice, setItemPrice] = useState("1000");
    const [itemCurrency, setItemCurrenty] = useState("MMK");
    const [itemCategory, setItemCategory] = useState("");
    const [categoryList, setCategoryList] = useState<string[]>([]);
    const [locationSelect, setLocationSelect] = useState(false);
    const [locations, setLocations] = useState<Location[]>([]);

    useIonViewWillEnter(() => {
        getData();
    });

    // refresh UI
    useEffect(() => {
        // init
        if (match.params.type == "market")
        {
            setAddTitle(true);
        }
    },[match.params.type]);

    // reload the data
    const getData = async () => {
        
        // upload the content
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            type: match.params.type
        }

        var server = new NServer();
        await server.getList("nc_addcontent", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            // go back to main
            router.push("/mainc", "back", "pop");
            return;
        }

        setChannel(server.data.channel);
        setName(server.data.name);
        setAvatar(server.data.avatar);
        setMetaList(server.data.metas);
        setContentMeta(server.data.meta);
        setMaxFileSize(server.data.max_vid);

        setTotalPosts(server.data.posts);
        setMaxPosts(server.data.max);

        if (match.params.type == "market")
        {
            setCategoryList(server.data.categories);
        }
    }

    // return to main
    const returnToMain = () => {
        if (match.params.type == "market")
            router.push("/token/market", "back", "pop");
        else
            router.push("/mainc", "back", "pop");
    }

    // close the UI
    const closeUI = async () => {
        if (!canPost())
        {
            returnToMain();
            return;
        }

        let result = await showConfirm(GetStr(LANGUAGE.TXT_VIDEO_ASK_CHANGE_CAP), GetStr(LANGUAGE.TXT_VIDEO_ASK_CHANGE));
        if (result.value)
        {
            returnToMain();
        }
    }

    // check for valid market item
    const checkValid = () : boolean => {
        if (match.params.type == "market")
        {
            // check for market item
            if (itemCategory == "")
            {
                showAlert(GetStr(LANGUAGE.TXT_ADD_INVALID_CAT));
                return false;
            }
            if (locations.length < 1)
            {
                showAlert(GetStr(LANGUAGE.TXT_ADD_INVALID_LOC));
                return false;
            }
            if (images.length == 0 && videoCode == "" && videoFile == "")
            {
                showAlert(GetStr(LANGUAGE.TXT_ADD_INVALID_IMG));
                return false;
            }
        }

        // else
        return true;
    }

    // upload the content
    const uploadContent = async () => {
        if (!canPost())
            return;
        if (!checkValid())
            return;

        setShowLoading(true);

        /* DEL
        if (videoFile != "")
        {
            // simply upload the video file
            console.log("Uploading video...");
            
            const formData = new FormData();
            
            await fetch(videoFile).then(
                res => res.blob()
            ).then(
                (res) => {
                    formData.append('video', res, videoFile);
                }
            );
        
            return fetch('https://nwallet.site/put_video.php', {
                method: 'POST',
                body: formData
            })
            .then(
                (res) => {
                    console.log("Upload: " + res);
                    setShowLoading(false);
                }
            ).catch(
                err => {
                    console.log("Upload err-> " + err);
                    setShowLoading(false);
                }
            );

            setShowLoading(false);
            return;
        }
        */

        let contentType = "text";
        if (videoCode != "")
            contentType = "video";
        else if (videoFile != "")
            contentType = "vidfile";
        else if (images.length > 0)
            contentType = "image";

        // upload the content
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            channel: channel,
            type: contentType,
            desc: desc,
            meta: contentMeta,
            video: videoCode,
            title: title,
            action: actionButType,
            nsfw: nsfw ? 1 : 0,
            ano: anoPost ? 1 : 0,
            add_type: match.params.type,
            price: itemPrice,
            currency: itemCurrency,
            category: itemCategory,
            locations: locations
        }

        var server = new NServer();
        
        await server.sendForm("nc_upload_content", state);
        if (!server.success && server.message != "")
        {
            setShowLoading(false);
            showAlert(server.message);
            return;
        }

        let contentID = server.data.content;

        // upload images if there are
        if (images != null && contentID >= 0)
        {
            for (let i = 0; i < images.length; i++)
            {
                if (images[i] !== undefined)
                {
                    const state = {
                        id: v.account.id,
                        pass: v.account.key,
                        name: contentID,
                        type: "ncimg"
                    };

                    var server = new NServer();
                    await server.uploadImage(images[i].webPath!, state);
                }
            }
        }
        // upload videos
        if (videoFile != "")
        {
            const state = {
                id: v.account.id,
                pass: v.account.key,
                name: contentID,
                type: "ncvid"
            };
            var server = new NServer();
            await server.uploadImage(videoFile, state);
        }

        // upload success
        setShowLoading(false);
        
        returnToMain();
    }

    // upload the images
    const uploadImages = async () => {
        // check for permission
        let status : PermissionStatus = await Camera.checkPermissions();
        if (status.photos != "granted")
        {
            status = await Camera.requestPermissions({permissions:["photos"]});
            if (status.photos == "denied")
                return;
        }

        if (images.length > 20)
        {
            showAlert("Maximun 20 images are supported per post.");
            return;
        }

        // request gallery
        const options : ImageOptions = {
            allowEditing : false,
            saveToGallery : false,
            source : CameraSource.Photos,
            resultType : CameraResultType.Uri
        };
        const photo : Photo = await Camera.getPhoto(options);
        
        if (images.length < 1)
            setImages([photo]);
        else
            setImages(images.concat([photo]));
        
        // disable video
        setVideoCode("");
        setAddVideo(false);
        setVideoURL("");
    }

    // upload the video file
    const uploadVideo = async () => {
        try
        {
            const result = await FilePicker.pickFiles({
                    types: ["video/3gpp", "video/3gpp2", "video/3gpp-tt", "video/mp4", "video/ogg", "video/H261", "video/H263", "	video/H264", "video/H265", "video/H266", "video/AV1", "	video/mpeg4-generic", "video/quicktime"],
                    multiple: false,
            });

            if (result.files.length == 0)
                return;

            // check for file size
            let fileSize = result.files[0].size;
            let maxSize = maxFileSize * (1024 * 1024);  // it comes in MB
            if (fileSize > maxSize)
            {
                showAlert(GetStr(LANGUAGE.TXT_MAX_CONTENT_SIZE_1) + maxFileSize + GetStr(LANGUAGE.TXT_MAX_CONTENT_SIZE_2));
                return;
            }

            // set the video filename
            if (result.files[0].blob != null)
            {
                let video = window.URL.createObjectURL(result.files[0].blob!);
                setVideoFile(video);
            }
            else
            {
                setVideoFile(Capacitor.convertFileSrc(result.files[0].path!));
            }

            setAddShow(false);
        }
        catch (err)
        {
        }
    }

    // add youtuve video
    const addYoutube = () => {
        setImages([]);
        setVideoCode("");
        setAddVideo(true);
        setAddShow(false);
    }
    
    // add title video
    const showTitle = () => {
        setAddTitle(!addTitle);
        setAddShow(false);
    }

    // add question video
    const addQuestion = () => {
        console.log("Add question");
    }

    // remove the image
    const removeImage = (index : number) => {
        if (images != null)
        {
            if (index >= 0)
            {
                images.splice(index, 1);
                setImages(Array.from(images));
            }
            else
                setImages([]);
        }
    }

    // check for whether it is a valid youtube video
    const setValidYouTubeCode = (code : string) => {
        // parse the video code
        if (code.length != 11)
        {
            var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            var match = code.match(regExp);
            let videoCodeParsed = (match&&match[7].length==11)? match[7] : false;

            if (!videoCodeParsed)
                return;
            
            setVideoCode(videoCodeParsed);
            setVideoURL("");
            setAddVideo(false);
        }
        else
        {
            if (code.match(/^[0-9A-Za-z]+$/))
            {
                setVideoCode(code);
                setVideoURL("");
                setAddVideo(false);
            }
        }
    }

    // set the video code
    const changeVideoCode = (code : string) => {
        setVideoURL(code);
        setValidYouTubeCode(code);
    }

    // paste the video code
    const pasteVideoCode = async () => {
        const { type, value } = await Clipboard.read();
        setVideoURL(value);
        setValidYouTubeCode(value);
    }

    // check whether we can post
    const canPost = () : boolean => {
        if (desc == "" && images.length == 0 && videoCode == "" && title == "" && videoFile == "")
            return false;
        // else
        return true;
    }

    // add the public chat button
    const addActionButType = (type : string) => {
        setAddShow(false);
        setShowActBut(false);

        setActionButType(type);

        if (type == "pchat")
            setActionButLbl(GetStr(LANGUAGE.TXT_PUBLIC_CHAT_JOIN));
    }

    // add the item location
    const addItemLocation = (loc : Location) => {
        // check whether location is already added
        for (let i = 0; i < locations.length; i++)
        {
            if (locations[i].id == loc.id)
                return;
        }

        let newLoc = locations.concat(loc);
        setLocations(newLoc);
    }

    // remove item location
    const removeItemLocation = (loc : Location) => {
        let index = locations.indexOf(loc);
        console.log("Removing " + loc.name_en + ", " + index);
        if (index >= 0)
        {
            locations.splice(index, 1);
            setLocations(JSON.parse(JSON.stringify(locations)));
        }
    }

    return (
        <IonPage>
            <IonHeader className="ion-no-border">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton onClick={closeUI}><IonIcon icon={arrowBackOutline} /></IonButton>
                    </IonButtons>
                    <IonTitle className="title"><h5>{GetStr(LANGUAGE.TXT_CREATE_CONTENT_CAP)} [{totalPosts} / {maxPosts}]</h5></IonTitle>
                    <IonButton className="ion-margin-end" slot="end" onClick={uploadContent}>{ GetStr(LANGUAGE.TXT_POST) }</IonButton>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonCol>
                            <IonItem lines="none" color="none">
                                <IonAvatar className="avt-size-large" slot="start">
                                    <img src={avatar} onError={ ({currentTarget}) => { currentTarget.src = 'assets/img/avt.jpg' } } />
                                </IonAvatar>
                                <IonLabel>
                                    <div><b>{ name }</b></div>
                                    <div>
                                        <IonItem className="ion-no-padding" color="none" lines="none">
                                            <IonLabel position="floating">{ GetStr(LANGUAGE.TXT_CONTENT_META) }</IonLabel>
                                            <IonSelect value={contentMeta} interface="action-sheet" onIonChange={e => setContentMeta(e.detail.value!)}>
                                                { metaList.map( m => 
                                                <IonSelectOption key={m.id} value={m.id}>
                                                    <IonItem>
                                                        {m.name} - {m.info}
                                                    </IonItem>
                                                </IonSelectOption>
                                                )} 
                                            </IonSelect>
                                        </IonItem>
                                    </div>
                                </IonLabel>
                            </IonItem>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            {
                                addTitle ? 
                            <IonCard className="flat-card">
                                <IonItem lines="full">
                                    <IonLabel position="floating">{GetStr(LANGUAGE.TXT_ARTICLE_TITLE)}</IonLabel>
                                    <IonInput value={title} onIonChange={ e => setTitle(e.detail.value!) }></IonInput>
                                </IonItem>
                                <IonButton className="ion-float-right" fill="clear" onClick={ ()=> { setAddTitle(false); setTitle(""); } }>
                                    <small><b>{ GetStr(LANGUAGE.TXT_CANCEL) }</b></small>
                                </IonButton>
                            </IonCard>
                                :
                            <div/>
                            }
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonItem className="ion-margin-bottom" color="none" lines="none">
                                <IonTextarea placeholder={ GetStr(LANGUAGE.TXT_WHATS_ON_MIND) } value={desc} rows={3} auto-grow maxlength={5000} onIonChange={e => setDesc(e.detail.value!)}></IonTextarea>
                            </IonItem>
                        </IonCol>
                    </IonRow>
                    {
                        images.length > 0 ?
                    <IonRow>
                        <IonCol>
                            {
                                images.length == 1 ?
                                <div className="over-close-wrap">
                                    <IonImg src={images[0].webPath}/>
                                    <IonButton className="over-close-but" fill="clear" onClick={()=> removeImage(-1) }>
                                        <IonIcon icon={closeCircleOutline} size="large"/>
                                    </IonButton>
                                </div>
                                :
                                <div className="thumbnail-list">
                                {
                                    images.map( (item, key) => {
                                        return (
                                            <div className="over-close-wrap" key={key}>
                                                <IonThumbnail className="img-preview">
                                                    <IonImg src={item.webPath} />
                                                </IonThumbnail>
                                                <IonButton className="over-close-but" fill="clear" onClick={()=> removeImage(key) }>
                                                    <IonIcon icon={closeCircleOutline} size="large"/>
                                                </IonButton>
                                            </div>
                                        )
                                    })
                                }
                                </div>
                            }
                        </IonCol>
                    </IonRow>
                        :
                        videoCode != "" ?
                    <IonRow>
                        <IonCol>
                            <div className="over-close-wrap">
                                <img className="video-thumbnail" src={"https://img.youtube.com/vi/" + videoCode + "/0.jpg"} />
                                <IonButton className="over-close-but" fill="clear" onClick={()=> setVideoCode("") }>
                                    <IonIcon icon={closeCircleOutline} size="large"/>
                                </IonButton>
                            </div>
                        </IonCol>
                    </IonRow>
                        :
                        addVideo ?
                    <IonRow>
                        <IonCol>
                            <IonCard className="flat-card">
                                <IonItem lines="none">
                                    <IonLabel position="floating">{GetStr(LANGUAGE.TXT_PASTE_VIDEO_CODE)}</IonLabel>
                                    <IonInput value={videoURL} onIonChange={ e => changeVideoCode(e.detail.value!) }></IonInput>
                                    <IonIcon icon={clipboardOutline} slot="end" onClick={pasteVideoCode}/>
                                </IonItem>
                                <IonButton className="ion-float-right" fill="clear" onClick={ ()=>setAddVideo(false) }>
                                    <small><b>{ GetStr(LANGUAGE.TXT_CANCEL) }</b></small>
                                </IonButton>
                            </IonCard>
                        </IonCol>
                    </IonRow>
                        :
                        videoFile != "" ?
                    <IonRow>
                        <IonCol>
                            <div className="over-close-wrap">
                                <video className="html-video-player" loop={true} autoPlay muted controls>
                                    <source src={videoFile} />
                                    Your browser does not support the video tag.
                                </video>
                                <IonButton className="over-close-but" fill="clear" onClick={()=> setVideoFile("") }>
                                    <IonIcon icon={closeCircleOutline} size="large"/>
                                </IonButton>
                            </div>
                        </IonCol>
                    </IonRow>
                        :
                    <div/>
                    }
                    {
                        /* action button */
                        actionButType != "" ?
                    <IonRow>
                        <IonCol>
                            <IonButton className="main-but ion-padding-start ion-padding-end ion-margin-top" expand="block">
                                    { actionButLbl }
                            </IonButton>
                            <IonButton className="ion-float-right" fill="clear" onClick={ ()=> { setActionButType("") } }>
                                <small><b>{ GetStr(LANGUAGE.TXT_CANCEL) }</b></small>
                            </IonButton>
                        </IonCol>
                    </IonRow>
                        :
                    <div/>
                    }

                    {
                        match.params.type == "market" ?
                    <div>
                        <IonRow>
                            <IonCol size="12" className="ion-padding">
                                <IonLabel>{ GetStr(LANGUAGE.TXT_ADD_SEL_CAT) }</IonLabel>
                                <IonSelect value={itemCategory} placeholder={GetStr(LANGUAGE.TXT_ADD_SEL_CAT_INFO)} onIonChange={(e)=> setItemCategory(e.detail.value!) }>
                                    {
                                        categoryList.map((s, index) => (
                                    <IonSelectOption key={index} value={""+index}>{ s }</IonSelectOption>
                                        ))
                                    }
                                </IonSelect>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol className="ion-padding">
                                <IonItem>
                                    <IonLabel position="floating">{ GetStr(LANGUAGE.TXT_ADD_ITEM_PRICE) }</IonLabel>
                                    <IonInput type="number" value={itemPrice} onIonChange={(e)=> setItemPrice(e.detail.value!) }></IonInput>
                                </IonItem>
                            </IonCol>
                            <IonCol className="ion-padding">
                                <IonItem>
                                    <IonLabel position="floating">{ GetStr(LANGUAGE.TXT_ADD_ITEM_CURRENCY) }</IonLabel>
                                    <IonSelect interface="popover" value={itemCurrency} onIonChange={(e)=> setItemCurrenty(e.detail.value!) }>
                                        <IonSelectOption value="MMK">MMK</IonSelectOption>
                                        <IonSelectOption value="USD">USD</IonSelectOption>
                                    </IonSelect>
                                </IonItem>
                            </IonCol>
                        </IonRow>                        
                        <IonRow>
                            <IonCol size="12" className="ion-padding">
                                <IonLabel>{ GetStr(LANGUAGE.TXT_ADD_AVAIL_LOCS) }</IonLabel>
                                {
                                    locations.map((s) => (
                                <IonItem key={s.id} lines="none">
                                    <IonIcon slot="start" icon={locationOutline} />
                                    <IonLabel>{ locationName(s) }</IonLabel>
                                    <IonIcon slot="end" icon={closeCircleOutline} onClick={()=> removeItemLocation(s)}/>
                                </IonItem>
                                )) }
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol className="ion-padding">
                                <IonButton color="secondary" expand="block" onClick={()=>setLocationSelect(true)}>
                                    { GetStr(LANGUAGE.TXT_ADD_LOC_ADD) }
                                </IonButton>
                            </IonCol>
                        </IonRow>
                    </div>
                        :
                    <div/>
                    }
                </IonGrid>
                
                <IonLoading
                    isOpen={showLoading}
                    onDidDismiss={() => setShowLoading(false)}
                    message={ GetStr(LANGUAGE.TXT_PLZ_WAIT) }
                />

                <LocationSelector
                    isOpen={locationSelect}
                    onDidDismiss={ ()=> setLocationSelect(false) }
                    onSelect={ addItemLocation }
                />
            </IonContent>
            <IonFooter>
                {
                    addShow ?
                (
                    showActBut ?
                <IonList>
                    <IonItem>
                        <IonLabel>{ GetStr(LANGUAGE.TXT_CONTENT_ADD_ACTION) }</IonLabel>
                        <IonButton slot="end" fill="clear" onClick={ ()=> setShowActBut(false) }><b>{ GetStr(LANGUAGE.TXT_CONTENT_ADD_HIDE) }</b></IonButton>
                    </IonItem>
                    <IonItem className="ion-activatable ripple-parent" lines="none" onClick={ ()=> addActionButType("pchat") } >
                        <IonIcon icon={chatboxEllipsesOutline} slot="start"/>
                        <IonLabel>{ GetStr(LANGUAGE.TXT_CONTENT_ADD_PUBLIC_CHAT) }</IonLabel>
                        <IonIcon icon={addOutline} slot="end"/>
                        <IonRippleEffect></IonRippleEffect>
                    </IonItem>
                </IonList>
                    :
                <IonList>
                    <IonItem>
                        <IonLabel>{ GetStr(LANGUAGE.TXT_CONTENT_ADD_CAP) }</IonLabel>
                        <IonButton slot="end" fill="clear" onClick={ ()=> setAddShow(false) }><b>{ GetStr(LANGUAGE.TXT_CONTENT_ADD_HIDE) }</b></IonButton>
                    </IonItem>
                    <IonItem className="ion-activatable ripple-parent" lines="none" onClick={uploadImages}>
                        <IonIcon icon={imagesOutline} slot="start"/>
                        <IonLabel>{ GetStr(LANGUAGE.TXT_CONTENT_ADD_PIC) }</IonLabel>
                        <IonIcon icon={addOutline} slot="end"/>
                        <IonRippleEffect></IonRippleEffect>
                    </IonItem>
                    <IonItem className="ion-activatable ripple-parent" lines="none" onClick={uploadVideo}>
                        <IonIcon icon={filmOutline} slot="start"/>
                        <IonLabel>{ GetStr(LANGUAGE.TXT_CONTENT_ADD_VIDEO_FILE) }</IonLabel>
                        <IonIcon icon={addOutline} slot="end"/>
                        <IonRippleEffect></IonRippleEffect>
                    </IonItem>
                    <IonItem className="ion-activatable ripple-parent" lines="none" onClick={addYoutube}>
                        <IonIcon icon={logoYoutube} slot="start"/>
                        <IonLabel>{ GetStr(LANGUAGE.TXT_CONTENT_ADD_VIDEO) }</IonLabel>
                        <IonIcon icon={addOutline} slot="end"/>
                        <IonRippleEffect></IonRippleEffect>
                    </IonItem>
                    <IonItem className="ion-activatable ripple-parent" lines="none" onClick={showTitle}>
                        <IonIcon icon={readerOutline} slot="start"/>
                        <IonLabel>{ GetStr(LANGUAGE.TXT_CONTENT_ADD_QUESTION) }</IonLabel>
                        <IonIcon icon={addOutline} slot="end"/>
                        <IonRippleEffect></IonRippleEffect>
                    </IonItem>
                    <IonItem className="ion-activatable ripple-parent" lines="none" onClick={ ()=> setShowActBut(true) } >
                        <IonIcon icon={hammerOutline} slot="start"/>
                        <IonLabel>{ GetStr(LANGUAGE.TXT_CONTENT_ADD_ACTION) }</IonLabel>
                        <IonIcon icon={addOutline} slot="end"/>
                        <IonRippleEffect></IonRippleEffect>
                    </IonItem>
                    {/*DEL
                    <IonItem className="ion-activatable ripple-parent" lines="none" onClick={addQuestion}>
                        <IonIcon icon={libraryOutline} slot="start"/>
                        <IonLabel>{ GetStr(LANGUAGE.TXT_CONTENT_ADD_TITLE) }</IonLabel>
                        <IonIcon icon={addOutline} slot="end"/>
                        <IonRippleEffect></IonRippleEffect>
                    </IonItem>
                    */}
                </IonList>
                )
                    :
                <IonList>
                    <IonGrid className="ion-no-padding">
                        <IonRow>
                            <IonCol size="6">
                                <IonItem lines="none">
                                    <IonCheckbox slot="start" value={nsfw} onIonChange={(e) => setNSFW(e.detail.checked)}></IonCheckbox>
                                    <IonLabel color={ nsfw ? "dark" : "medium" }>{ GetStr(LANGUAGE.TXT_CHECK_NSFW) }</IonLabel>
                                </IonItem>
                            </IonCol>
                            <IonCol size="6">
                                <IonItem lines="none">
                                    <IonCheckbox slot="start" value={anoPost} onIonChange={(e) => setAnoPost(e.detail.checked)}></IonCheckbox>
                                    <IonLabel color={ anoPost ? "dark" : "medium" }>{ GetStr(LANGUAGE.TXT_ANONYMOUS_POST) }</IonLabel>
                                </IonItem>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                    <IonItem className="ion-activatable ripple-parent" lines="none" onClick={()=> setAddShow(true)}>
                        <IonIcon className="icon-row" icon={imagesOutline}/>
                        <IonIcon className="icon-row" icon={filmOutline}/>
                        <IonIcon className="ion-padding-end" icon={logoYoutube}/>
                        <IonLabel>{ GetStr(LANGUAGE.TXT_CONTENT_ADD_CAP) }</IonLabel>
                        <IonIcon icon={chevronUpOutline} slot="end"/>
                        <IonRippleEffect></IonRippleEffect>
                    </IonItem>
                </IonList>
                }
            </IonFooter>
        </IonPage>
    );
};

export default AddContent;